import React from 'react';
import classnames from 'classnames';

import './pagination.scss';
import { usePagination, DOTS } from './usePagination';
const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  let lastPage = paginationRange[paginationRange.length - 1];
  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };
  const onFastNext = () => {
    onPageChange(lastPage);
  };

  const onFastPrevious = () => {
    onPageChange(1);
  };

 
  return (
    <ul
      className={classnames('pagination-container', { [className]: className })}
    >
        <li
        className={classnames('pagination-item', {
          disabled: currentPage === 1
        })}
        onClick={onFastPrevious}
      >
        <div className="arrow left" />
        <div className="arrow left" />
      </li>
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === 1
        })}
        onClick={onPrevious}
      >
        <div className="arrow left" />
      </li>
      {paginationRange.map(pageNumber => {
        if (pageNumber === DOTS) {
          return <li className="pagination-item dots">&#8230;</li>;
        }

        return (
          <li
            className={classnames('pagination-item', {
              selected: pageNumber === currentPage
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage
        })}
        onClick={onNext}
      >
        <div className="arrow right" />
      </li>
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage
        })}
        onClick={onFastNext}
      >
        <div className="arrow right" />
        <div className="arrow right" />
      </li>
    </ul>
  );
};

export default Pagination;